/**
 * Rails/Rack style query serialization.
 *
 * Axios emits `filter[type_id][0]=2` for nested arrays, and Rack parses that as
 * a hash `{ "0" => "2" }`, not an array. Rails expects `filter[type_id][]=2`.
 * Brackets are left unescaped so URLs stay readable, exactly like axios does.
 */
const encode = (value: string) =>
  encodeURIComponent(value).replace(/%5B/gi, '[').replace(/%5D/gi, ']')

function serializePair(key: string, value: unknown, pairs: string[]) {
  if (value === null || value === undefined) return

  if (Array.isArray(value)) {
    value.forEach((item) => serializePair(`${key}[]`, item, pairs))
    return
  }

  if (value instanceof Date) {
    pairs.push(`${encode(key)}=${encode(value.toISOString())}`)
    return
  }

  if (typeof value === 'object') {
    Object.entries(value as Record<string, unknown>).forEach(
      ([childKey, childValue]) =>
        serializePair(`${key}[${childKey}]`, childValue, pairs)
    )
    return
  }

  pairs.push(`${encode(key)}=${encode(String(value))}`)
}

export function serializeParams(params: unknown): string {
  if (!params || typeof params !== 'object') return ''

  const pairs: string[] = []

  Object.entries(params as Record<string, unknown>).forEach(([key, value]) =>
    serializePair(key, value, pairs)
  )

  return pairs.join('&')
}
